"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.logout = void 0;
var logout = {
  "viewBox": "0 0 64 64",
  "children": [{
    "name": "g",
    "attribs": {
      "id": "LOGOUT_1_",
      "enable-background": "new    "
    },
    "children": [{
      "name": "g",
      "attribs": {
        "id": "LOGOUT"
      },
      "children": [{
        "name": "g",
        "attribs": {
          "id": "LOGOUT"
        },
        "children": [{
          "name": "g",
          "attribs": {},
          "children": [{
            "name": "g",
            "attribs": {},
            "children": [{
              "name": "path",
              "attribs": {
                "d": "M56,32c0-0.885-0.383-1.681-0.993-2.23l0,0l-10-9l0,0C44.475,20.292,43.771,20,43,20c-1.657,0-3,1.343-3,3\r\n\t\t\t\tc0,0.885,0.384,1.681,0.993,2.23l0,0L45.182,29H27l0,0c-1.657,0-3,1.343-3,3s1.343,3,3,3l0,0h18.182l-4.188,3.77l0,0\r\n\t\t\t\tC40.384,39.32,40,40.115,40,41c0,1.657,1.343,3,3,3c0.771,0,1.475-0.292,2.007-0.77l0,0l10-9l0,0C55.617,33.682,56,32.885,56,32z\r\n\t\t\t\t M26,52H14V12h12c1.657,0,3-1.343,3-3s-1.343-3-3-3H11C9.343,6,8,7.343,8,9v46c0,1.657,1.343,3,3,3h15c1.657,0,3-1.343,3-3\r\n\t\t\t\tS27.657,52,26,52z"
              },
              "children": [{
                "name": "path",
                "attribs": {
                  "d": "M56,32c0-0.885-0.383-1.681-0.993-2.23l0,0l-10-9l0,0C44.475,20.292,43.771,20,43,20c-1.657,0-3,1.343-3,3\r\n\t\t\t\tc0,0.885,0.384,1.681,0.993,2.23l0,0L45.182,29H27l0,0c-1.657,0-3,1.343-3,3s1.343,3,3,3l0,0h18.182l-4.188,3.77l0,0\r\n\t\t\t\tC40.384,39.32,40,40.115,40,41c0,1.657,1.343,3,3,3c0.771,0,1.475-0.292,2.007-0.77l0,0l10-9l0,0C55.617,33.682,56,32.885,56,32z\r\n\t\t\t\t M26,52H14V12h12c1.657,0,3-1.343,3-3s-1.343-3-3-3H11C9.343,6,8,7.343,8,9v46c0,1.657,1.343,3,3,3h15c1.657,0,3-1.343,3-3\r\n\t\t\t\tS27.657,52,26,52z"
                },
                "children": []
              }]
            }]
          }]
        }]
      }]
    }]
  }]
};
exports.logout = logout;